import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import cx from 'classnames';
import styles from './ModalTitle.module.scss';
const ModalTitle = ({ className, children, ...props }) => (_jsx("div", { className: cx(styles.modalTitle, className), ...props, children: children }));
export default Object.assign(memo(ModalTitle), { displayName: 'ModalTitle' });
